// Reducer for hook state and actions
const reducer = (state, action) => {
  switch (action.type) {
    case 'idle':
      return {
        status: 'idle',
        data: undefined,
        firstDocument: undefined,
        lastDocument: undefined,
        hasMorePage: false,
        error: undefined,
      };
    case 'loading':
      return {
        status: 'loading',
        data: undefined,
        firstDocument: undefined,
        lastDocument: undefined,
        hasMorePage: false,
        error: undefined,
      };
    case 'success':
    case 'nextPage':
    case 'prevPage': {
      //To check hasMorepage, increment pageLimit by 1 and if response pagelist is greater then min_row
      //then set hasMorepage to true
      const document = action.payload.data;
      const pageLimit = action.payload.pageLimit;

      const listLength = document.length;
      let hasMorePage = listLength > pageLimit;
      let firstDocument = document[0];
      let lastDocument = document[listLength - 1];
      const dataDoc = document.map(item => item.data());

      if (action.type === 'prevPage') {
        if (hasMorePage) {
          dataDoc.shift();
          firstDocument = document[1];
        }
        hasMorePage = true;
      }

      if ((action.type === 'nextPage' || action.type === 'success') && hasMorePage) {
        lastDocument = document[listLength - 2];
        dataDoc.pop();
      }
      return {
        status: 'success',
        data: dataDoc,
        lastDocument: lastDocument,
        firstDocument: firstDocument,
        hasMorePage: hasMorePage,
        error: undefined,
      };
    }

    case 'error':
      return {
        status: 'error',
        data: undefined,
        firstDocument: undefined,
        lastDocument: undefined,
        hasMorePage: false,
        error: action.payload.data,
      };
    default:
      throw new Error('invalid action');
  }
};

export default reducer;
